import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DriverWorkflow } from '@symfa-inc/providence-types';
import { Spin } from 'antd';
import { HttpService } from '@core/services';
import {
  DriverManagementHttpService,
  PermittingHttpService,
} from '@core/services/http';
import { usePermittingTabPrefetch } from '@core/utils/hooks';
import { getProjectBundleIDParamFromUrl } from '@core/utils/methods';
import { Financial } from '@shared/components/financial';
import { PermittingActions } from '@store/actions';
import { PermittingSelectors } from '@store/selectors';

export const PermittingFinancial: FC = () => {
  const dispatch = useDispatch();
  const [projectBundleID] = getProjectBundleIDParamFromUrl();

  const isLoading = useSelector(
    PermittingSelectors.getTabLoadingState('financial'),
  );
  const isDataLoaded = useSelector(
    PermittingSelectors.isTabDataLoaded('financial'),
  );

  usePermittingTabPrefetch('financial', projectBundleID);

  const fetchData = async () => {
    if (!isDataLoaded) {
      dispatch(
        PermittingActions.setTabLoading.done({
          tabName: 'financial',
          isLoading: true,
        }),
      );

      await HttpService.getHttpRequests(
        PermittingHttpService,
      ).getPermittingFinancialData(projectBundleID);

      await HttpService.getHttpRequests(
        DriverManagementHttpService,
      ).getDriversListByWorkflow(DriverWorkflow.Permitting);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch, isDataLoaded]);

  if (isLoading || !isDataLoaded) {
    return (
      <div className="prov-permitting-financial loading">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Financial
      feeAccessPath="permitting"
      siteDataRootPath={['permitting', 'tabData', 'summary', 'site']}
      projectTypeSelector={PermittingSelectors.getProjectType}
      projectIdSelector={PermittingSelectors.getProjectId}
    />
  );
};
